import React from 'react'

import { Div, PromotionWidget } from '@sendoutcards/quantum-design-ui'
import {
  getAffiliateUpsaleMarketingContent,
  UserType,
} from 'src/legacy_graphql'
import { useAccount, useQueries, useState } from 'src/hooks'
import AffiliateUpsaleDialog from '../containers/AffiliateUpsaleDialog'
import suspenseBoundary from 'src/chrome/SuspenseBoundary/suspenseBoundaryHOC'
import { CircularProgress } from '@material-ui/core'

const AffiliateUpsale: React.FC = () => {
  const {
    type: userType,
    isEligibleForFreeGsAffiliateAccount,
    hasFullAccessFreeAffiliate,
  } = useAccount()
  const [marketingContent] = useQueries(getAffiliateUpsaleMarketingContent())
  const [shouldOpenAffUpsale, setShouldOpenAffUpsale] = useState(false)

  const legacyRepUserTypes: UserType[] = [
    UserType.D,
    UserType.ID,
    UserType.MD,
    UserType.PBD,
    UserType.MBD,
    UserType.BBD,
  ]

  const isPro = userType === UserType.GSA
  const isFreeGSA = userType === UserType.FGSA
  const isLegacyRep = legacyRepUserTypes.includes(userType)

  const title: { type: string; text: string } = isPro
    ? {
        type: 'affiliateUpsellGSATitle',
        text: marketingContent.affiliateUpsellGSATitle.content,
      }
    : isFreeGSA
    ? {
        type: 'affiliateUpsellFGSATitle',
        text: marketingContent.affiliateUpsellFGSATitle.content,
      }
    : isLegacyRep
    ? {
        type: 'affiliateUpsellSOCAffiliateTitle',
        text: marketingContent.affiliateUpsellSOCAffiliateTitle.content,
      }
    : {
        type: 'affiliateUpsellCRCTitle',
        text: marketingContent.affiliateUpsellCRCTitle.content,
      }

  const description: { type: string; text: string } = isPro
    ? {
        type: 'affiliateUpsellGSAContent',
        text: marketingContent.affiliateUpsellGSAContent.content,
      }
    : isFreeGSA
    ? {
        type: 'affiliateUpsellFGSAContent',
        text: marketingContent.affiliateUpsellFGSAContent.content,
      }
    : isLegacyRep
    ? {
        type: 'affiliateUpsellSOCAffiliateContent',
        text: hasFullAccessFreeAffiliate
          ? marketingContent.affiliateUpsellSOCAffiliateContentFreeAffiliate
              .content
          : marketingContent.affiliateUpsellSOCAffiliateContent.content,
      }
    : hasFullAccessFreeAffiliate
    ? {
        type: 'affiliateUpsellSOCAffiliateContent',
        text:
          marketingContent.affiliateUpsellSOCAffiliateContentFreeAffiliate
            .content,
      }
    : {
        type: 'affiliateUpsellCRCContent',
        text: marketingContent.affiliateUpsellCRCContent.content,
      }

  const buttonTitle: { type: string; text: string } = isPro
    ? {
        type: 'affiliateUpsellGSAButtonTitle',
        text: marketingContent.affiliateUpsellGSAButtonTitle.content,
      }
    : isFreeGSA || isLegacyRep
    ? {
        type: 'affiliateUpsellFGSADButtonTitle',
        text: marketingContent.affiliateUpsellFGSADButtonTitle.content,
      }
    : {
        type: 'affiliateUpsellCRCButtonTitle',
        text: marketingContent.affiliateUpsellCRCButtonTitle.content,
      }

  const buttonOnclick = isPro
    ? () => {
        window.open(
          marketingContent.compPlanTrainingLink.url,
          '_blank',
          'noopener,noreferrer',
        )
      }
    : () => {
        window.location.href = 'app.sendoutcards.com/app/promo?promo=112'
      }

  return (
    <Div
      outset={{ bottom: 'x1_5' }}
      data-aupw={isPro ? 'pro' : 'freeOrCustomer'}
      data-mktcontent={`title: ${title.type} | description: ${description.type} | buttonTitle: ${buttonTitle.type}`}
    >
      <PromotionWidget
        title={title.text}
        description={description.text}
        primaryAction={{
          title: buttonTitle.text,
          onClick: buttonOnclick,
        }}
        capsuleTitle="New"
        width="100%"
        minWidth="320px"
        type="success"
      />
      {shouldOpenAffUpsale && (
        <>
          <AffiliateUpsaleDialog
            isEligibleForFreeGsAffiliateAccount={
              isEligibleForFreeGsAffiliateAccount
            }
            hasFullAccessFreeAffiliate={hasFullAccessFreeAffiliate}
            onClose={() => {
              setShouldOpenAffUpsale(false)
            }}
          />
        </>
      )}
    </Div>
  )
}

export default suspenseBoundary({
  component: AffiliateUpsale,
  failure: () => false,
  unresolved: <CircularProgress />,
})
